'use client';

import {
  showLikeAtom,
  showTocAtom,
} from 'app/blog/[domain]/_components/design-state';
import { useAtomValue } from 'jotai';
import { AsideActions, type AsideActionProps } from './aside-actions';
import { TOC as Toc, type TocProps } from './toc/toc';

export type PostAsideProps = AsideActionProps & TocProps;

export function PostAside({ toc, likeCount, postId }: PostAsideProps) {
  const { showAside, showLike, showToc } = useShowAside({ toc });
  if (!showAside) return null;
  const renderToc = showToc && toc.length > 0;
  const actions = showLike ? (
    <AsideActions postId={postId} likeCount={likeCount} />
  ) : null;
  return (
    <aside className="post-aside">
      {renderToc ? <Toc toc={toc}>{actions}</Toc> : actions}
    </aside>
  );
}

export type ShowAsideProps = { toc: TocProps['toc'] };

export function useShowAside({ toc }: ShowAsideProps) {
  const showToc = useAtomValue(showTocAtom);
  const showLike = useAtomValue(showLikeAtom);
  const showAside = (showToc && toc.length > 0) || showLike;
  return { showAside, showLike, showToc };
}
